<template>
  <div class="st-table">
    <el-row :gutter="12">
      <el-form class="form" ref="form" :model="form" :rules="rules" label-position="left" label-width="145px" label-colon>
        <el-col :span="10" >
          <el-card shadow="always">
              <el-row :gutter="16">
                <el-col :span="3">
                  <el-form-item label="Product Name" prop="product_id">
                    <el-select v-model="form.product_id"
                               clearable
                               filterable
                               remote
                               style="width:260px"
                               :loading="isReqsFetching"
                               :remote-method="fetchProduct"
                               @change="onProductChange"
                    >
                      <el-option
                        v-for="(item, index) in options.productList"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Alias Name">
                  <el-input
                    v-model="form.alias_name"
                    style="width:260px"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
              <el-row :gutter="16">
                <el-col :span="3">
                  <el-form-item label="Plan Version">
                    <el-input
                      v-model="form.plan_version"
                      style="width:260px"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="3">
                  <el-form-item label="Actual Version">
                    <el-input
                      v-model="form.actual_version"
                      style="width:260px"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="3">
                  <el-form-item label="Requirement">
                    <el-select v-model="form.req_ids"
                               clearable
                               multiple
                               style="width:260px"
                    >
                      <el-option
                          v-for="item in options.reqList"
                          :key="item.index"
                          :label="item.reqNo"
                          :value="item.reqNo">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="3">
                  <el-form-item label="Due Date">
                    <el-date-picker
                      v-model="form.due_date"
                      type="date"
                      style="width:260px"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="3">
                  <el-form-item label="Project Type" prop="project_type">
                    <el-select v-model="form.project_type"
                               clearable
                               style="width:260px">
                      <el-option
                        v-for="(item, index) in this.product_type"
                        :key="index"
                        :label="item.label"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="3">
                  <el-form-item label="Project Manager" prop="pm_id">
                    <el-select v-model="form.pm_id"
                               clearable
                               style="width:260px">
                      <el-option
                        v-for="item in options.pmList"
                        :key="item"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="3">
                  <el-form-item label="Status" prop="status">
                    <el-select v-model="form.status"
                               clearable
                               style="width:260px">
                      <el-option
                        v-for="item in this.statusList"
                        :key="item"
                        :label="item.label"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="3">
                  <el-form-item label="Project Status" prop="d_status">
                    <el-select v-model="form.d_status"
                               clearable
                               style="width:260px">
                      <el-option
                        v-for="item in this.d_statusList"
                        :key="item"
                        :label="item.label"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="3">
                  <el-form-item label="Links">
                    <el-input
                      v-model="form.links"
                      style="width:260px"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
          </el-card>
        </el-col>
        <el-col :span="14">
          <el-card shadow="always">
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Plan Start Date" prop="plan_start">
                  <el-date-picker
                    v-model="form.plan_start"
                    type="date"
                    style="width:260px"
                    value-format="yyyy-MM-dd"
                    @change="changeStart"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Plan End Date" prop="plan_end">
                  <el-date-picker
                    v-model="form.plan_end"
                    type="date"
                    @change="changeEnd"
                    style="width:260px"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Plan Days">
                  <el-input
                    style="width:260px"
                    :disabled="true"
                    v-model="form.plan_days"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Actual Start Date">
                  <el-date-picker
                    v-model="form.actual_start"
                    type="date"
                    style="width:260px"
                    value-format="yyyy-MM-dd"
                    @change="a_changeStart"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Actual End Date">
                  <el-date-picker
                    v-model="form.actual_end"
                    type="date"
                    style="width:260px"
                    value-format="yyyy-MM-dd"
                    @change="a_changeEnd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Actual Days">
                  <el-input
                    style="width:260px"
                    v-model="form.actual_days"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Adjust Days">
                  <el-input
                    style="width:260px"
                    v-model="form.adjust_days"
                    @change="final_days_change"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="3">
                <el-form-item label="Final Days">
                  <el-input
                    style="width:260px"
                    :disabled="true"
                    v-model="form.final_days"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="1">
                <el-button type="primary" @click="submitProject('form')">
                  Submit
                </el-button>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-form>
    </el-row>

  </div>
</template>

<script>

import userApi from "@/api/user";
import productApi from "@/api/product";
import projectApi from "@/api/project";
import reqApi from "@/api/req";
import _ from "lodash";

export default {
  name: "project",
  data() {
    return {
      product_type: ['New','Upgrade'],
      statusList:['To Do','In Progress','Hold','Complete'],
      d_statusList:['To Do','Designing','Developing','Testing','Debug/Bug fixing','Releasing','Archive'],
      detail:'',
      loading: false,
      isReqsFetching: false,
      form: {
        "product_id":'',
        "alias_name":'',
        "plan_version":'',
        "actual_version":'',
        "req_ids":'',
        "project_type":'',
        "due_date":'',
        "pm_id":'',
        "status":'',
        "d_status":'',
        "links":'',
        "attachment":'',
        "plan_start":'',
        "plan_end":'',
        "plan_days":'',
        "actual_start":'',
        "actual_end":'',
        "actual_days":'',
        "adjust_days":'',
        "final_days": ''
      },
      options: {
        pmList: [],
        productList: [],
        reqList:[]
      },
      rules:{
        product_id: [{
          required:true, message:'Please Input', trigger:'blur'
        }],
        project_type: [{
          required:true, message:'Please Input', trigger:'blur'
        }],
        pm_id: [{
          required:true, message:'Please Input', trigger:'blur'
        }],
        status: [
          {
            required:true, message:'Please Input', trigger:'blur'
          }
        ],
        d_status: [
          {
            required:true, message:'Please Input', trigger:'blur'
          }
        ],
        plan_start:[
          {
            required:true, message:'Please Input', trigger:'blur'
          }
        ],
        plan_end:[
          {
            required:true, message:'Please Input', trigger:'blur'
          }
        ],
      },
    }
  },
  methods: {
    // dataFilter(node: { text: string; }, val: string) {
    //   if (!!~node.text.indexOf(val) || !!~node.text.toUpperCase().indexOf(val.toUpperCase())) {
    //     return true
    //   }
    // },
    changeStart(){
      if (this.form.plan_end !== undefined||this.form.plan_start !== undefined) {
        if (this.form.plan_end < this.form.plan_start) {
          this.$alert("Plan Start Date must be earlier than plan end Date！", { dangerouslyUseHTMLString: true });
          this.form.plan_start = undefined;
        }
        var ONE_DAY = 1000 * 60 * 60 * 24
        //console.log(this.form.plan_end)
        var date1_ms = new Date(this.form.plan_end).getTime()
        var date2_ms = new Date(this.form.plan_start).getTime()
        var difference_ms = Math.abs(date1_ms - date2_ms)
        this.form.plan_days =Math.round(difference_ms/ONE_DAY+1);
      }
    },
    changeEnd(){
      //console.log(this.form.plan_end);
      if (this.form.plan_end !== undefined||this.form.plan_start !== undefined) {
        if (this.form.plan_end < this.form.plan_start) {
          this.$alert("Plan Start Date must be earlier than plan end Date！", { dangerouslyUseHTMLString: true });
          this.form.plan_end = undefined;
        }
        var ONE_DAY = 1000 * 60 * 60 * 24
        //console.log(this.form.plan_end)
        var date1_ms = new Date(this.form.plan_end).getTime()
        var date2_ms = new Date(this.form.plan_start).getTime()
        var difference_ms = Math.abs(date1_ms - date2_ms)
        this.form.plan_days =Math.round(difference_ms/ONE_DAY+1);
      }
    },
    a_changeStart(){
      if (this.form.actual_end !== undefined||this.form.actual_start !== undefined) {
        if (this.form.actual_end < this.form.actual_start) {
          this.$alert("Actual Start Date must be earlier than actual end Date！", { dangerouslyUseHTMLString: true });
          this.form.actual_start = undefined;
        }

        var ONE_DAY = 1000 * 60 * 60 * 24
        //console.log(this.form.actual_end)
        var date1_ms = new Date(this.form.actual_end).getTime()
        var date2_ms = new Date(this.form.actual_start).getTime()
        var difference_ms = Math.abs(date1_ms - date2_ms)
        this.form.actual_days =Math.round(difference_ms/ONE_DAY+1);
      }
    },
    a_changeEnd(){
      if (this.form.actual_end !== undefined||this.form.actual_start !== undefined) {
        if (this.form.actual_end < this.form.actual_start) {
          this.$alert("Actual Start Date must be earlier than actual end Date！", { dangerouslyUseHTMLString: true });
          this.form.actual_end = undefined;
        }
        var ONE_DAY = 1000 * 60 * 60 * 24
        //console.log(this.form.actual_end)
        var date1_ms = new Date(this.form.actual_end).getTime()
        var date2_ms = new Date(this.form.actual_start).getTime()
        //console.log(date2_ms)
        var difference_ms = Math.abs(date1_ms - date2_ms)
        //console.log(difference_ms)
        this.form.actual_days =Math.round(difference_ms/ONE_DAY+1);
        //console.log(this.form.actual_end)
      }
    },
    final_days_change(){
      this.form.final_days = parseInt(this.form.actual_days) + parseInt(this.form.adjust_days)
    },
    submitProject() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          let payload = this.form
          payload['product_id'] = this.form.product_id
          payload['alias_name'] = this.form.alias_name
          payload['plan_version'] = this.form.plan_version
          payload['actual_version'] = this.form.actual_version
          payload['due_date'] = this.form.due_date
          payload['project_type'] = this.form.project_type
          payload['pm_id'] = this.form.pm_id
          payload['status'] = this.form.status
          payload['d_status'] = this.form.d_status
          payload['links'] = this.form.links
          payload['plan_start'] = this.form.plan_start
          payload['plan_end'] = this.form.plan_end
          payload['actual_start'] = this.form.actual_start
          payload['actual_end'] = this.form.actual_end
          payload['adjust_days'] = this.form.adjust_days
          projectApi.createProject(payload).then()
          this.loading = false
        } else {
          this.$message.error("Please filled with form")
        }
      })
    },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.options.pmList.push({value: user.id, label: user["fullName"]})
        }
      })
      // productApi.getProducts().then(res=> {
      //     let products = res.data
      //     for (let product of products) {
      //       this.options.productList.push({value: product.id, label: product.name})
      //     }
      //   })
      // requirementApi.getReqList().then(res=> {
      //     let reqs = res.data
      //     for (let req of reqs) {
      //       this.options.reqList.push({value: req.id, label: req.reqNo })
      //     }
      // })

    },
    onProductChange(val) {
      Object.assign(this.form, {
        req_id: undefined,
      })
      this.fetchReqs(val)
    },
    fetchProduct(query) {
      if (query !== '') {
        this.isReqsFetching = true
        productApi.getProducts(query.trim()).then(({data}) => {
          this.isReqsFetching = false
          this.options.productList = (data || []).map(item => {
            return {
              value: item.id,
              label: item.name,
              key: item.id,
            }
          })
        })
      } else {
        this.options.productList = []
      }
    },
    fetchReqs(product_id) {
      reqApi.getReqList(product_id).then(res => {
        this.options.reqList = res.data.data
      })
    },
  },
  mounted(){
    this.getSelects()
  },
  watch: {
    formData: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        const newProductId = _.get(newVal, 'product_id')
        if (newProductId && !_.get(oldVal, 'product_id')) {
          this.fetchProduct()
          this.fetchReqs(newProductId)
        }
      }
    },
  },
}


</script>

<style scoped>
</style>
